export default __webpack_public_path__ + "static/media/alertExample.63e2a72b.PNG";